//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;
  var Types = require('./Types');


  module.exports.RecipientType = {
    'USER' : 1,
    'BUSINESS' : 2
  };

  module.exports.EntityPrivilegeLevel = {
    'READ' : 1,
    'EDIT' : 2
  };

  module.exports.PrivilegeSharing = {
    'MANAGE' : 1
  };

  module.exports.PrivilegeValues = Thrift.Struct.define('PrivilegeValues',  {
    1: { alias: 'level', type: Thrift.Type.I32 },
    2: { alias: 'sharing', type: Thrift.Type.I32 }
  });

  module.exports.InvitationCommon = Thrift.Struct.define('InvitationCommon',  {
    1: { alias: 'guid', type: Thrift.Type.STRING },
    2: { alias: 'entityOwnerId', type: Thrift.Type.I32 },
    3: { alias: 'sharerUserId', type: Thrift.Type.I32 },
    4: { alias: 'serviceCreated', type: Thrift.Type.I64 },
    5: { alias: 'serviceUpdated', type: Thrift.Type.I64 },
    6: { alias: 'serviceAssigned', type: Thrift.Type.I64 },
    7: { alias: 'membershipGuid', type: Thrift.Type.STRING }
  });

  module.exports.InternalInvitation = Thrift.Struct.define('InternalInvitation',  {
    1: { alias: 'common', type: Thrift.Type.STRUCT, def: module.exports.InvitationCommon },
    2: { alias: 'entityType', type: Thrift.Type.I32 },
    3: { alias: 'entityId', type: Thrift.Type.I64 },
    4: { alias: 'privilegeValues', type: Thrift.Type.STRUCT, def: module.exports.PrivilegeValues },
    5: { alias: 'identity', type: Thrift.Type.STRUCT, def: Types.Identity },
    6: { alias: 'entityGuid', type: Thrift.Type.STRING }
  });

  module.exports.MembershipCommon = Thrift.Struct.define('MembershipCommon',  {
    1: { alias: 'guid', type: Thrift.Type.STRING },
    2: { alias: 'recipientType', type: Thrift.Type.I32 },
    3: { alias: 'recipientId', type: Thrift.Type.I64 },
    4: { alias: 'sharerUserId', type: Thrift.Type.I32 },
    7: { alias: 'entityOwnerId', type: Thrift.Type.I32 },
    9: { alias: 'serviceCreated', type: Thrift.Type.I64 },
    10: { alias: 'serviceUpdated', type: Thrift.Type.I64 }
  });

  module.exports.InternalMembership = Thrift.Struct.define('InternalMembership',  {
    1: { alias: 'common', type: Thrift.Type.STRUCT, def: module.exports.MembershipCommon },
    2: { alias: 'entityType', type: Thrift.Type.I32 },
    3: { alias: 'entityId', type: Thrift.Type.I64 },
    4: { alias: 'privilegeValues', type: Thrift.Type.STRUCT, def: module.exports.PrivilegeValues },
    5: { alias: 'entityGuid', type: Thrift.Type.STRING }
  });

  module.exports.CreateOrGetInternalInvitationResponse = Thrift.Struct.define('CreateOrGetInternalInvitationResponse',  {
    1: { alias: 'invitation', type: Thrift.Type.STRUCT, def: module.exports.InternalInvitation },
    2: { alias: 'created', type: Thrift.Type.BOOL }
  });

